<template>
  <template v-if="!model.showSuccessForm">
    <FormHeader :title="_e('header_title')" :image="_e('header_image')" :back-url="_e('header_back_url')" />
    <div id="sac-scroll-anchor"></div>
    <SacNavigation></SacNavigation>

    <SacStep1></SacStep1>

    <SacStep2></SacStep2>

    <SacStep3></SacStep3>
  </template>
  <FormSuccess v-else
    :title="model.showSuccessForm.title"
    :text="model.showSuccessForm.text"
    :link="model.showSuccessForm.link"
    :link_label="model.showSuccessForm.link_label"
  />
</template>

<script setup>
import { useSacStore } from '../store/SacStore';
const model = useSacStore();

import SacNavigation from '../components/sections/SAC/SacNavigation.vue';
import SacStep1 from '../components/sections/SAC/SacStep1.vue';
import SacStep2 from '../components/sections/SAC/SacStep2.vue';
import SacStep3 from '../components/sections/SAC/SacStep3.vue';
import { watch } from 'vue';
import FormHeader from '../components/sections/FormHeader.vue';
import { _e } from '../helpers/l10n';
import FormSuccess from '../components/sections/FormSuccess.vue';

watch(() => model.etapaAtiva, (n) => {
  setTimeout(()=>{
    return window.scrollTo(0, document.querySelector('#sac-scroll-anchor').offsetTop);
  }, 200);
});

</script>
